import React, { useEffect, useState, useRef } from 'react';
import './opportunityMapping.css';
import CustomButton from '../../components/Buttons/Button';
import type { ColumnsType, ColumnType, TablePaginationConfig } from 'antd/es/table';
import { Button, Divider, Input, Select, Space, Spin, Table, Tooltip, notification } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBuAndClientDetails_Opportunity, fetchMappedClientName, fetchOpportunityDetails, fetchOpportunityDetails_usd, fetchOpportunityDetailsById, setOpportunityModalIsOpen, updateOpportunity } from '../../store/reducers/orderDashboardSlice';
import { rejectedApiMessage } from '../../utilities/CommonHelper';
import FloatLabel from '../../components/FloatLabel/floatLabel';
import Highlighter from 'react-highlight-words';
import type { InputRef } from 'antd';
import type { FilterConfirmProps } from 'antd/es/table/interface';
import { InfoCircleOutlined, SearchOutlined, CloseOutlined } from '@ant-design/icons';
import Link from 'antd/es/typography/Link';
interface Props {
  onSubmit: () => void;
  onCancel: () => void;
  selectedSOW: any;
  isOpen: boolean;
  action :any;
}
interface DataType {
  key: React.Key;
  Id: string;
  mainOpportunityName: string;
  Name: string;
  businessType: string;
  description: string;
  geography: string;
  Owner:any;
  Total_contract_value__c:any;
  CurrencyIsoCode:any;
  CloseDate:any;
  X11_Annual_Contract_Value__c:any;
  Main_Opportunity__r: string;
}

// const data: DataType[] = [];
// for (let i = 0; i < 100; i++) {
//   data.push({
//     key: i,
//     Id: `Map Opportunity to create Order ID ${i}`,
//     mainOpportunityName: `Map Opportunity to create Order ID ${i}`,
//     opportunityName: `opportunityName ${i}`,
//     businessType: `bussinessType ${i}`,
//     description: `description ${i}`,
//     geography: `geography ${i}`
//   });
// }


// const form_fields: {
//   label: string;
//   placeholder: string;
//   id: string;
//   required: boolean;
//   disabled: boolean,
//   options?: { label: string, value: string }[];
//   type: 'textbox' | 'selectDropdown' | 'multilineTextbox'
// }[] = [
//     {
//       label: 'Client Entity ',
//       placeholder: 'Indegene',
//       id: 'clientEntity',
//       required: true,
//       disabled: false,
//       type: 'selectDropdown',
//       options: [{ label: 'Something1', value: 'something1' }, { label: 'Something2', value: 'Something2' }, { label: 'Something3', value: 'Something3' }, { label: 'Something 4', value: 'Something4' }, { label: 'Something 5', value: 'Something5' }]

//     },
//     {
//       label: 'BU',
//       placeholder: 'Enter BU',
//       id: 'bu',
//       required: true,
//       disabled: false,
//       type: 'selectDropdown',
//       options: [{ label: 'Something1', value: 'something1' }, { label: 'Something2', value: 'Something2' }, { label: 'Something3', value: 'Something3' }, { label: 'Something 4', value: 'Something4' }, { label: 'Something 5', value: 'Something5' }]

//     },  {
//       label: 'Search',
//       placeholder: 'Search by ‘ID’',
//       id: 'parentId',
//       required: false,
//       disabled: false,
//       type: 'textbox'
//     }
//   ]
  type DataIndex = keyof DataType; 

const OpportunityMappingForm: React.FC<Props> = (props:any) => {
  const dispatch = useDispatch();
  const selectRef = useRef<any>(null);
  const orderDashboardData=useSelector((state:any)=>state.orderDashboard);
  const [selectedSOWDetails, setSelectedSOWDetails] = React.useState<any>({});
  const [selectedOpportunityId, setSelectedOpportunityId] = React.useState<string>('');
  const [selectedRow, setSelectedRow] = React.useState<any>({});
  const [selectedOpportunityName, setSelectedOpportunityName] = React.useState<string>('');
  const [selectedOpportunityTCV, setSelectedOpportunityTCV] = React.useState<string>('');
  const [selectedOpportunityCurrency, setSelectedOpportunityCurrency] = React.useState<string>('');
  const [selectedCloseDate, setSelectedCloseDate] = React.useState<string>('');
  const [pageNo, setPageNo] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [buList, setBuList] = useState<any[]>([]);
  const [clientEntityList, setClientEntityList] = useState<any[]>([]);
  const [selectedBu, setSelectedBu] = useState<any>("");
  const [selectedClientEntity, setSelectedClientEntity] = useState<any>("");
  const [opportunityList, setOpportunityList] = useState<any[]>([]);

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef<InputRef>(null);

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex,
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex: DataIndex): ColumnType<DataType> => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              setSelectedKeys([]);
              handleSearch([], confirm, dataIndex);
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          {/* <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button> */}
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
    ),
    onFilter: (value, record) =>{
      let _value= value?value.toString().toLowerCase():'';
      let _record=record[dataIndex]?record[dataIndex].toString().toLowerCase():'';
      return _record
        .toString()
        .toLowerCase()
        .includes((_value));
    }
      ,
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const columns: ColumnsType<DataType> = [
    {
      title: 'Opportunity ID',
      width: 150,
      dataIndex: 'Id',
      key: 'Id',
      fixed: 'left',
      ...getColumnSearchProps('Id'),
    },
    {
      title: 'Main Opportunity Name ',
      width: 200,
      dataIndex: 'Main_Opportunity__r',
      key: 'Main_Opportunity__r',
      ...getColumnSearchProps('Main_Opportunity__r'),
    //   render: (value, record:any) => {
    //     // console.log('record', record)
    //     return record.Main_Opportunity__r ? record.Main_Opportunity__r.Name : '-';
    // },
    },
    {
      title: 'Opportunity Name',
      dataIndex: 'Name',
      key: 'Name',
      width: 200,
      ...getColumnSearchProps('Name'),
    },
    {
      title: 'Total Contract Value',
      dataIndex: 'Total_contract_value__c',
      key: 'Total_contract_value__c',
      width:150,
      render: (value:any, record:any) => {
        return <span>{value == 0.0  && record.totalSum > 0 ? record.totalSum : value}</span>;
      }
      // sorter: (a:any, b:any) => a.Total_contract_value__c - b.Total_contract_value__c
    },
    {
      title: 'Annual Contract Value',
      dataIndex: 'X11_Annual_Contract_Value__c',
      key: 'X11_Annual_Contract_Value__c',
      width:150,
      ...getColumnSearchProps('X11_Annual_Contract_Value__c'),
      render: (value:any, record:any) => {
        return <span>{value ? value : '-'}</span>;
      }
    },
    {
      title: 'Currency',
      dataIndex: 'CurrencyIsoCode',
      key: 'CurrencyIsoCode',
      width:150,
      ...getColumnSearchProps('CurrencyIsoCode'),
    },
    {
      title: 'Close Date',
      dataIndex: 'CloseDate',
      key: 'CloseDate',
      width:150,
    },
    {
      title: 'Business Type',
      dataIndex: 'Booking_Type__c',
      key: 'Booking_Type__c',
      width: 150,
  
    },
    {
      title: 'Business Unit',
      dataIndex: 'Business_Segment__c',
      key: 'Business_Segment__c',
      width: 150,
      render: (value, record:any) => {
        return value ? fetchBULabel(value) : '-';
      }
    },
    {
      title: 'Description',
      dataIndex: 'Description__c',
      key: 'Description__c',
      width: 150,
      render: (value:any, record:any) => {
        return <span>{value ? value : '-'}</span>;
    },
    },
    {
      title: 'Geography',
      dataIndex: 'Geography_Customer__c',
      key: 'Geography_Customer__c',
      width: 150,
    },
    {
      title: 'Opportunity Owner',
      dataIndex: 'Owner',
      key: 'Owner',
      width:150,
      // render: (value, record:any) => {
      //     return record.Owner.Name;
          
      // }
      // ,
      ...getColumnSearchProps("Owner"),
    },
    {
        title: 'Stage Name',
        dataIndex: 'StageName',
        key: 'StageName',
        width:150,
        // ...this.getColumnSearchProps('StageName')  
    },
    {
      title: 'Action',
      fixed: 'right',
      key: 'Action',
      width: 100,
      render: (text: string, record: any) => {
        return(
          <> {
            orderDashboardData.opportunityModal.action!=="view" &&
          <> 
          {selectedOpportunityId===record.Id?
            <a className='maplink' onClick={()=>UnMapOpportunityId()}>Delink</a>:
            // <a className='maplink' onClick={()=>mapOpportunityId(record)}>Link</a>
            <>
            <Link className='maplink' onClick={()=>mapOpportunityId(record)} disabled= {record.isParent } >Link</Link> 
            {/* {record.totalSum!==null && record.Total_contract_value__c == 0.0 && <Tooltip title="This is a Master Opportunity. Please link the SOWs to the Child Opportunities under the Master Opportunity."> <InfoCircleOutlined/></Tooltip>} */}
            {record.isParent && <Tooltip title="This is a Master Opportunity. Please link the SOWs to the Child Opportunities under the Master Opportunity."> <InfoCircleOutlined/></Tooltip>}
            </>
            }</>
          }</>
        )
      }
    },
  ];
  const columns_view: ColumnsType<DataType> = [
    {
      title: 'Opportunity ID',
      width: 150,
      dataIndex: 'Id',
      key: 'Id',
      fixed: 'left',
      // ...getColumnSearchProps('Id'),
    },
    {
      title: 'Main Opportunity Name ',
      width: 200,
      dataIndex: 'Main_Opportunity__c',
      key: 'Main_Opportunity__c',
      render: (value, record:any) => {
        // console.log('record', record)
        return record.Main_Opportunity__r ? record.Main_Opportunity__r.Name : '-';
    },
    },
    {
      title: 'Opportunity Name',
      dataIndex: 'Name',
      key: 'Name',
      width: 200,
      // ...getColumnSearchProps('Name'),
    },
    {
      title: 'Total Contract Value',
      dataIndex: 'Total_contract_value__c',
      key: 'Total_contract_value__c',
      width:150,
      render: (value:any, record:any) => {
        return <span>{value == 0.0  && record.totalSum > 0 ? record.totalSum : value}</span>;
      }
      // sorter: (a:any, b:any) => a.Total_contract_value__c - b.Total_contract_value__c
    },
    {
      title: 'Annual Contract Value',
      dataIndex: 'X11_Annual_Contract_Value__c',
      key: 'X11_Annual_Contract_Value__c',
      width:150,
      ...getColumnSearchProps('X11_Annual_Contract_Value__c'),
      render: (value:any, record:any) => {
        return <span>{value ? value : '-'}</span>;
      }
    },
    {
      title: 'Currency',
      dataIndex: 'CurrencyIsoCode',
      key: 'CurrencyIsoCode',
      width:150,
      // ...getColumnSearchProps('CurrencyIsoCode'),
    },
    {
      title: 'Close Date',
      dataIndex: 'CloseDate',
      key: 'CloseDate',
      width:150,
    },
    {
      title: 'Business Type',
      dataIndex: 'Booking_Type__c',
      key: 'Booking_Type__c',
      width: 150,
  
    },
    {
      title: 'Business Unit',
      dataIndex: 'Business_Segment__c',
      key: 'Business_Segment__c',
      width: 150,
      render: (value, record:any) => {
        return value ? fetchBULabel(value) : '-';
      }
    },
    {
      title: 'Description',
      dataIndex: 'Description__c',
      key: 'Description__c',
      width: 150,
      render: (value:any, record:any) => {
        return <span>{value ? value : '-'}</span>;
    },
    },
    {
      title: 'Geography',
      dataIndex: 'Geography_Customer__c',
      key: 'Geography_Customer__c',
      width: 150,
    },
    {
      title: 'Opportunity Owner',
      dataIndex: 'Owner',
      key: 'Owner',
      width:150,
      // render: (value, record:any) => {
      //     return record.Owner.Name;
          
      // }
      // ,
      // ...getColumnSearchProps("Owner"),
    },
    {
        title: 'Stage Name',
        dataIndex: 'StageName',
        key: 'StageName',
        width:150,
        // ...this.getColumnSearchProps('StageName')  
    }
  ];

  const fetchBULabel = (Business_Segment__c:any) => {
    if(Business_Segment__c && buList.length>0){
      let temp = buList.filter((item:any)=>item.value===Business_Segment__c);
      return temp[0]?.label || '-';
    }
    return '-';
  }

  const mapOpportunityId = (record:any) => {
    // setSelectedRow(record);
    setSelectedOpportunityId(record.Id);
    setSelectedOpportunityName(record.Name)
    setSelectedOpportunityTCV(record.Total_contract_value__c);
    setSelectedOpportunityCurrency(record.CurrencyIsoCode);
    setSelectedCloseDate(record.CloseDate);
    setSelectedBu(record.Business_Segment__c);
    fetchOpportunityMoreDetails(record);
  };

  const fetchOpportunityMoreDetails = (record:any) => {
    dispatch(fetchOpportunityDetails_usd({'record':record})).then((res: any) => {
      if (res.type === 'orderDashboard/fetchOpportunityDetails_usd/fulfilled') {
        setSelectedRow(res.payload);
      }else{
        rejectedApiMessage(res.payload);
      }
    });
  }
  const UnMapOpportunityId = () => {
    setSelectedRow({});
    setSelectedOpportunityId('');
    setSelectedOpportunityName('');
    setSelectedOpportunityTCV('');
    setSelectedOpportunityCurrency('');
    setSelectedCloseDate('');
    setSelectedBu('');
  };
  
  const handleSubmit = () => {
    // if(selectedRow && (selectedRow.sowMappedValue + selectedSOWDetails.contractValueUSD)>selectedRow.totalOppContractValueUsd){
    //   rejectedApiMessage("Sum of Total Contract Value of SOWs mapped to the Opportunity can not be more than the Total Contract Value of the Opportunity");
    //   return;
    // }
    dispatch(updateOpportunity({'sowId':selectedSOWDetails.sowId,'opportunityId':selectedOpportunityId,'opportunityName': selectedOpportunityName,'client':selectedClientEntity, 'bu': selectedBu, action:orderDashboardData.opportunityModal.action,'OppContractValue':selectedOpportunityTCV,'CurrencyIsoCode': selectedOpportunityCurrency, 'closeDate':selectedCloseDate})).then((res: any) => {
      if (res.type === 'orderDashboard/updateOpportunity/fulfilled') {
        
        notification.success({message: 'Success', description: 'Opportunity Mapped Successfully' });
        setSelectedRow({});
        setSelectedOpportunityId('');
        setSelectedOpportunityName('');
        setSelectedOpportunityTCV('');
        setSelectedOpportunityCurrency('');
        setSelectedCloseDate('');
        dispatch(setOpportunityModalIsOpen({isMOdalOpen:false,selectedSOW:{}}));
        props.onSubmit();
      }else{
        rejectedApiMessage(res.payload);
      }
    });
    // event.preventDefault();
    // const formData = new FormData(event.currentTarget);
    // const values: any = {};
    // console.log(formData);
    // formData.forEach((value, key) => {
    //   values[key] = value;
    // });
    // onSubmit();
    // event.currentTarget.reset();
  };
  const handleCancel = () => {
    dispatch(setOpportunityModalIsOpen({isMOdalOpen:false,selectedSOW:{}}));
    props.onCancel();
  }

  const handleChangedValue = (id:any,value: any) => {
    selectRef.current?.blur();
    if(id==='clientEntity'){
      setSelectedClientEntity(value);
      setSelectedBu("");
      fetchOpportunityDetailsWithPagination(value,"");
    }
    if(id==='bu'){
      setSelectedBu(value);
      fetchOpportunityDetailsWithPagination(selectedClientEntity,value);
    }
  }


  useEffect(() => {
    if(orderDashboardData.opportunityModal.selectedSOW && Object.keys(orderDashboardData.opportunityModal.selectedSOW).length > 0){
      setSelectedSOWDetails(orderDashboardData.opportunityModal.selectedSOW);
      if(orderDashboardData.opportunityModal.isModalOpen && orderDashboardData.opportunityModal.action!="view"){
          if(orderDashboardData.opportunity_BuList?.length>=0 && orderDashboardData.opportunity_clientEntityList?.length>=0){
            setBuList(orderDashboardData.opportunity_BuList);
            setClientEntityList(orderDashboardData.opportunity_clientEntityList);
          
        
          }else{
                dispatch(fetchBuAndClientDetails_Opportunity()).then((res: any) => {
                  if (res.type === 'orderDashboard/fetchBuAndClientDetails_Opportunity/fulfilled') {
                    setBuList(res.payload?.buList?res.payload?.buList:[]);
                    setClientEntityList(res.payload?.clientList?res.payload?.clientList:[]);
                    
                  }else{
                    rejectedApiMessage(res.payload);
                  } 
                });
          }
          dispatch(fetchMappedClientName({clientEntity: encodeURIComponent(orderDashboardData.opportunityModal.selectedSOW.clientEntity)})).then((res: any) => {
            if (res.type === 'orderDashboard/fetchMappedClientName/fulfilled') {

              if(res.payload.length>0){
                setSelectedClientEntity(res.payload[0] || '');
              // setSelectedBu(res.payload.bu);
              fetchOpportunityDetailsWithPagination(res.payload[0] || '','');
              }
              
            }else{
              rejectedApiMessage(res.payload);
            } 
          });
      }
      else if(orderDashboardData.opportunityModal.isModalOpen && orderDashboardData.opportunityModal.action==="view"){
        if(orderDashboardData.opportunity_BuList?.length>=0 && orderDashboardData.opportunity_clientEntityList?.length>=0){
          setBuList(orderDashboardData.opportunity_BuList);
          setClientEntityList(orderDashboardData.opportunity_clientEntityList);
        
      
        }else{
              dispatch(fetchBuAndClientDetails_Opportunity()).then((res: any) => {
                if (res.type === 'orderDashboard/fetchBuAndClientDetails_Opportunity/fulfilled') {
                  setBuList(res.payload?.buList?res.payload?.buList:[]);
                  setClientEntityList(res.payload?.clientList?res.payload?.clientList:[]);
                  
                }else{
                  rejectedApiMessage(res.payload);
                } 
              });
        }
        dispatch(fetchOpportunityDetailsById({id:orderDashboardData.opportunityModal.selectedSOW.opportunityId})).then((res: any) => {
          if (res.type === 'orderDashboard/fetchOpportunityDetailsById/fulfilled') {
            setOpportunityList(res.payload.records);
        // setTotalCount(res.payload.totalElements);
            setSelectedRow({});
            setSelectedOpportunityId('');
            setSelectedOpportunityName('');
            setSelectedOpportunityTCV('');
            setSelectedOpportunityCurrency('');
            setSelectedCloseDate('');
            fetchOpportunityMoreDetails(res.payload.records[0]);
            
          }else{
            rejectedApiMessage(res.payload);
          } 
        });
      }
      else if(orderDashboardData.opportunityModal.isModalOpen && orderDashboardData.opportunityModal.action==="view"){
        dispatch(fetchOpportunityDetailsById({id:orderDashboardData.opportunityModal.selectedSOW.opportunityId})).then((res: any) => {
          if (res.type === 'orderDashboard/fetchOpportunityDetailsById/fulfilled') {
            setOpportunityList(res.payload.records);
        // setTotalCount(res.payload.totalElements);
            setSelectedRow({});
            setSelectedOpportunityId('');
            setSelectedOpportunityName('');
            
          }else{
            rejectedApiMessage(res.payload);
          } 
        });
      }
    }else{
      setSelectedBu("");
      setSelectedClientEntity("");
      setSelectedOpportunityId('');
      setSelectedRow({});
      setSelectedOpportunityName('');
      setSelectedOpportunityTCV('');
      setSelectedOpportunityCurrency('');
      setSelectedCloseDate('');
      setClientEntityList([]);
      setBuList([]);
      setOpportunityList([]);
      setPageNo(0);
    }
  }, [orderDashboardData.opportunityModal.selectedSOW,orderDashboardData.opportunityModal.isModalOpen,orderDashboardData.opportunityModal.action]);
  


  const fetchOpportunityDetailsWithPagination = (selectedClient :any,selectedBu:any) => {
    dispatch(fetchOpportunityDetails({'client':selectedClient,'bu':selectedBu})).then((res: any) => {
      if (res.type !== 'orderDashboard/fetchOpportunityDetails/fulfilled') {
        rejectedApiMessage(res.payload);
      }else{
        setOpportunityList(res.payload.records);
        // setTotalCount(res.payload.totalElements);
        setSelectedOpportunityId('');
        setSelectedRow({});
        setPageNo(0);
        setSelectedOpportunityName('');
        setSelectedOpportunityTCV('');
        setSelectedOpportunityCurrency('');
        setSelectedCloseDate('');
    } 
    });
  }
  const handleTableChange = (pagination: TablePaginationConfig) => {
    const { current, pageSize } = pagination;
    setPageNo(current ? current - 1 : 0);
    setPageSize(pageSize || 10);
  };

  const getopportunityList = (_opportunityList:any[]) => {
    if(_opportunityList.length>0){
        let temp:any= [];
        _opportunityList.map((item:any)=>{
          temp.push({...item,Owner:item.Owner?item.Owner.Name:'-'});
        })
        return temp;
    }
    return _opportunityList;
  }
  const handleClear_bu = () => {
    setSelectedBu("");
    fetchOpportunityDetailsWithPagination(selectedClientEntity,"");
  }

  return (
    <>
    {orderDashboardData.opportunityModal.isModalOpen &&
    <div style={{ background: '#F2F6FA', margin: '15px', padding: '15px' }}>
      <div style={{marginBottom:'10px'}}>
      <span style={{font:'12px / 20px "Nunito Sans"',fontWeight:'bold'}}>SOW : {selectedSOWDetails?.sowName}</span>
      </div>
      
      
      <div  className="form-component" style={{ maxWidth: '100%' }}>
      <Spin spinning={orderDashboardData?.loading} tip="Loading...">
        { 
        orderDashboardData.opportunityModal.action!=="view" && 
        <>
        <div className='row' style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div className='col-lg-4 col-md-4 col-sm-12 custom-fieldcolumn'>
          <FloatLabel label="Client Name *" value={selectedClientEntity}> 
             {/* <AutoComplete
            id='clientEntity'
            size="middle"
            value={selectedClientEntity}
            onSelect={(value:string)=>handleChangedValue('clientEntity',value)}
            style={{ width: 400,height:58,marginRight:'10px' }}
            disabled={clientEntityList.length>0?false:true}
            options={clientEntityList.length>0?clientEntityList.map((item:any) => ({ value: item })):undefined}
            placeholder="Select Client Entity"
            filterOption={(inputValue:any, option:any) => option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            // required={field.required}
            /> */}
            <Select
              showSearch
              allowClear={false}
              size='middle'
              ref={selectRef}
              // style={{ width: 200 }}
              style={{ width: '100%',height:58,marginRight:'10px' }}
              placeholder="Select Client Entity"
              optionFilterProp="children"
              value={selectedClientEntity}
              onSelect={(value:string)=>handleChangedValue('clientEntity',value)}
              
              // onFocus={onFocus}
              // onBlur={onBlur}
              // onSearch={onSearch}
              filterOption={(input:any, option:any) =>
                  option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={[...clientEntityList].sort((a: any, b: any) => a.localeCompare(b)).map((item:any) => ({ value: item }))}
          >
          </Select> 
        </FloatLabel>
        </div>
        <div className='col-lg-4 col-md-4 col-sm-12 custom-fieldcolumn'>
          <FloatLabel label="Business Unit " value={selectedBu}>
            {/* <AutoComplete
            id='bu'
            size="middle"
            value={selectedBu}
            onSelect={(value:string)=>handleChangedValue('bu',value)}
            style={{ width: 400,height:58,marginRight:'10px' }}
            disabled={selectedClientEntity?false:true}
            placeholder="Select Business Unit"
            options={buList}
            filterOption={(inputValue, option) => option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            // required={field.required}
            /> */}
            <Select
              showSearch
              allowClear = {{clearIcon :<CloseOutlined/>} } 
              // clearIcon = {<span><CloseOutlined/></span>} 
              size='middle'
              ref={selectRef}
              // style={{ width: 200 }}
              style={{ width: '100%',height:58,marginRight:'10px' }}
              placeholder="Select Business Unit"
              optionFilterProp="children"
              value={selectedBu}
              onSelect={(value:string)=>handleChangedValue('bu',value)}
              
              // onFocus={onFocus}
              // onBlur={onBlur}
              // onSearch={onSearch}
              onClear={()=>handleClear_bu()}
              filterOption={(input:any, option:any) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={[...buList].sort((a: any, b: any) => (a.label || '').localeCompare(b.label || '')).map((item:any) => ({ value: item.value,label:item.label }))}
          >
          </Select> 
          </FloatLabel>
        </div>
        {/* <div className='col-lg-4 col-md-4 col-sm-12' style={{display:'flex',justifyContent:'end', alignItems:'center'}}>
          <CustomButton  label="Search" type="submit" disabled={selectedBu && selectedClientEntity ?false:true} onClick={()=>handlegetOpportunity()} />
        </div> */}
        </div>
        <div style={{marginTop:'-12px', marginBottom:'12px',marginLeft:'5px'}}>
          <span className='' style={{font:'normal normal 600 12px / 16px Nunito Sans', color: '#024EA2'}} > Its recommended to select Business Unit for faster data fetching.</span>
        </div>
        </>
        }
        <div>
          <Table 
          className='table-style'
          columns={
            orderDashboardData.opportunityModal.action!=="view"?
            columns:
            columns_view} 
          dataSource={getopportunityList(opportunityList)} 
          // loading={orderDashboardData?.loading}
          scroll={{ x: 'max-content', y: 250}} 
          pagination={{
            current: pageNo + 1,
            pageSize,
            total: totalCount,
            showSizeChanger: false,

          }}
          rowKey={'Id'}
          onChange={handleTableChange}
          />
          {
            selectedRow && selectedRow.Id && <div>
              <Divider > <span style={{font:'normal normal 600 14px / 16px Nunito Sans', color: '#024EA2'}}>{orderDashboardData.opportunityModal.action!=="view" ? "More details of selected Opportunity":"More details of the Opportunity"}</span></Divider>
              <div style={{display:'flex',justifyContent:'space-between'}}>
              <div><span style={{font:'normal normal 600 14px / 16px Nunito Sans'}}>Opportunity Total Contract Value(USD) : {selectedRow.totalOppContractValueUsd}</span></div>
              <div><span style={{font:'normal normal 600 14px / 16px Nunito Sans'}}>SOW's Mapped Total Contract Value (USD) : {selectedRow.sowMappedValue}</span></div>
              <div><span style={{font:'normal normal 600 14px / 16px Nunito Sans'}}>Opportunity Remaining Contract Value to be mapped (USD) : {selectedRow.oppRemainingValue}</span></div>
              </div>
            </div>
          }
        </div>
        </Spin>
        { orderDashboardData.opportunityModal.action!=="view" &&
        <div className="form-buttons" style={{ display: 'flex', justifyContent: 'end', marginTop:"20px" }}>
          <CustomButton label="Cancel" type="cancel" onClick={()=>handleCancel()} />
          <CustomButton label="Submit" type="submit" disabled={selectedOpportunityId?false:true} onClick={()=>handleSubmit()} />
        </div>
        }
      </div>
      
    </div>
        }
        </>
  );
};

export default OpportunityMappingForm;